export default "__VITE_ASSET__B2CV7Z_i__"